"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixins = void 0;
require("styled-components");
require("./colors");
const flex_1 = require("./flex");
require("./media");
require("./types");
exports.mixins = {
    flex: flex_1.flex,
    textOverflow: (props) => {
        if ((props === null || props === void 0 ? void 0 : props.linesCount) && props.linesCount > 1) {
            return `
            overflow: hidden;
            white-space: normal;
            -webkit-line-clamp: ${props.linesCount};
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            display: -webkit-box;
          `;
        }
        return `
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `;
    },
};
